import { useCallback } from 'react'

import { EventInfo, EventStatus } from '~/gamification/types/gamification.types'
import { selectEvents, setFunfactActionCreator } from '~/gamification/slices/gamification.slice'
import { useAppDispatch, useAppSelector } from '~/redux/hooks'

import { useUpdateEventDataMutation } from '~/redux/apis/reward-api'

import Chest from './Chest/Chest'
import { ChestSize } from './Chest/types'

interface Props {
  event?: EventInfo
  eventId: string
  funfact?: unknown[]
  size?: ChestSize
  onClick?: () => void
}

export function GameChestContainer(props: Props): React.ReactElement {
  const { event, eventId, funfact, size = 'x-small', onClick } = props

  const events = useAppSelector(selectEvents)
  const dispatch = useAppDispatch()

  const chestEventIsCompleted = events?.some(({ id, status }) => eventId === id && status === EventStatus.COMPLETED)
  const awardPoints = chestEventIsCompleted ? 0 : event?.points ?? 0

  const [updateEventsData] = useUpdateEventDataMutation()

  const handleOnAnimationDidEnd = useCallback(() => {
    if (funfact) {
      dispatch(setFunfactActionCreator(funfact))
    }

    if (eventId && !chestEventIsCompleted) {
      updateEventsData([{ id: eventId, ...event, status: EventStatus.COMPLETED }])
    }
  }, [chestEventIsCompleted, dispatch, updateEventsData, event, eventId, funfact])

  return (
    <div className="flex justify-center">
      <Chest
        awardPoints={awardPoints}
        didCollectAward={false}
        key={eventId}
        onAnimationDidEnd={handleOnAnimationDidEnd}
        onClick={onClick}
        size={size}
      />
    </div>
  )
}
